export default __webpack_public_path__ + "static/logoEligibilite-6362e048d29ad9ad4feba8371163abb0.png";